var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }